import React from "react";
import { Box, Text, VStack } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import SharedUserItem from "./SharedUserItem";
import LoadingSkeleton from "./LoadingSkeleton";
import SharedWithAllCustomersCard from "./SharedWithAllCustomersCard";

interface SharedWithUsersListProps {
  sharedList: any[];
  setUsersList: any;
  showOptions: boolean;
  loadingUsers: boolean;
  sharedByAdminCount: number | undefined;
  sharedByAdminTimestamp: number | undefined;
  acceptanceRate: number | undefined;
}

const SharedWithUsersList: React.FC<SharedWithUsersListProps> = ({
  sharedList,
  setUsersList,
  showOptions,
  loadingUsers,
  sharedByAdminCount,
  sharedByAdminTimestamp,
  acceptanceRate,
}) => {
  const intl = useIntl();


  return (
    <Box mt={6}>
      <Text fontSize="16px" fontWeight="600" color="gray.900" mb={4}>
        {intl.formatMessage({ id: "sharing.recentSharesHistory" })}
      </Text>

      <Box
        sx={{
          maxHeight: loadingUsers ? "auto" : "270px",
          overflowY: loadingUsers ? "visible" : "auto",
        }}
      >
        {!loadingUsers ? (
          sharedByAdminTimestamp && sharedByAdminCount && acceptanceRate !== undefined ? (
            <SharedWithAllCustomersCard
              sharedByAdminCount={sharedByAdminCount}
              sharedByAdminTimestamp={sharedByAdminTimestamp}
              acceptanceRate={acceptanceRate}
            />
          ) : (
            <VStack spacing={3} align="stretch">
              {sharedList.map((sharedItem, index) => {
                const { approvalFlowStatus, createdAt } = sharedItem;

                const date = new Date(+createdAt);
                const formattedDate = date.toLocaleString();

                return (
                  <SharedUserItem
                    key={sharedItem.id || index}
                    sharedItem={sharedItem}
                    setUsersList={setUsersList}
                    showOptions={showOptions}
                    sharedStatus={approvalFlowStatus}
                    sharedDate={formattedDate}
                  />
                );
              })}
            </VStack>
          )
        ) : (
          <LoadingSkeleton showOptions={showOptions} />
        )}
      </Box>
    </Box>
  );
};

export default SharedWithUsersList;
